export const trevKeys = {
  all: ["threatEvents"] as const,
  details: (elementId: string | null, elementName: string | null) =>
    [...trevKeys.all, "elementTrevs", elementId, elementName] as const,
};
